<template>
    <div class="home-card-body">
        <div class="spinner-container position-absolute w-100 h-100 d-flex justify-content-center align-items-center" v-if="isLoading">
            <spring-spinner
                :animation-duration="3000"
                :size="60"
                color="#ff1d5e"
            />
        </div>
        <h2 class="home-card-title home-card-title-small" style="line-height: 1.5;">
            <input type="text" class="daterangepicker-init form-control" id="job-profitability-daterange" :value="date">
            {{value}}%
        </h2>
        <div class="home-card-subtitle">
            Job Profitability
        </div>
        <div class="home-card-button">
            <a class="btn btn-secondary" :href="'/jobs?date_range=' + date">View Jobs</a>
        </div>
    </div>
</template>

<script>
    import { SpringSpinner } from 'epic-spinners';

    export default {
        components: { SpringSpinner },

        name: "JobProfitability",

        props: {
            initialDate: {
                required: true,
                type: String
            }
        },

        data() {
            return {
                isLoading: true,
                value: 0,
                date: null
            }
        },

        mounted(){
            this.date = this.initialDate;

            $('#job-profitability-daterange').on('apply.daterangepicker', (e, picker) => {
                this.date = $('#job-profitability-daterange').val();
                this.getData();
            });

            return this.getData();
        },

        methods: {
            getData: function(){
                this.isLoading = true;
                axios.get('/jobs/profitability', {
                    params: {
                        dateRange: this.date
                    }
                }).then(response => {
                    this.value = response.data.value;
                    this.isLoading = false;
                });
            }
        }
    }
</script>
